import React from 'react';
import './style.scss';
import propTypes from './propTypes';

const RelatedLink = ({openInNewTab, url, text}) => (
    <a href={url} className="related-link" target={openInNewTab ? '_blank' : ''} >{text}</a>
);

RelatedLink.propTypes = propTypes;

RelatedLink.defaultProps = {
    openInNewTab: false
};

export default RelatedLink;



// WEBPACK FOOTER //
// ./src/components/RelatedLinks/RelatedLink/index.js